import React from 'react'
import { Box, Button } from '@mui/material'
import images from 'assets/images'
import { URL_HOME } from 'helpers/config'
import SignUpBuyerOptions from 'components/pages/signup/SignUpBuyerOptions'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import SignupTemplate from 'components/templates/SignupTemplate'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import FullScreenLoading from 'components/ui/FullScreenLoading'
import SignUpTotalSaving from 'components/pages/signup/SignUpTotalSaving'

const advantages: Advantage[] = [
  {
    image: images.signUp.CONTROL,
    alt: 'control your subscriptions',
    text: '<strong>Take control of your subscriptions and expenses</strong> by creating virtual VISA credit cards.*',
  },
  {
    image: images.signUp.DISCOVER,
    alt: 'discover highly vetted saas',
    text: '<strong>Discover highly vetted SaaS products relevant to your business</strong> using our AI powered recommendation engine.',
  },
  // {
  //   image: images.signUp.LIFETIME_DISCOUNTS,
  //   alt: 'get 1.5% cashback',
  //   text: '<strong>Get up to 30% lifetime discounts</strong> on thousands of highly vetted SaaS software products.',
  // },
]

const SignUpBuyer: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  if (loading) return <FullScreenLoading />

  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="30px" />

          <Box>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">Welcome to the World's Largest</h2>
            <h2 className="text-blue fs-32 fw-700 m-0">B2B SaaS Marketplace</h2>
          </Box>

          <SignUpTotalSaving sx={{ marginTop: '16px' }} />

          <Box height="70px" />

          <AdvantagesContainer advantages={advantages} />

          <Box height="41px" />

          <Box pl={{ xs: 0, xl: '40px' }}>
            <span className="fs-12 text-light-grey-1">
              *We don’t check your credit score and don’t report back to credit reporting agencies. Issue unlimited cards with 0%
              interest.
            </span>
          </Box>

          <Box height="27px" />

          <Button href={`${URL_HOME}/support-call`} variant="text" className="fs-14 text-blue">
            Request a video call
            <KeyboardArrowRightIcon className="blue" fontSize="small" sx={{ ml: '3px' }} />
          </Button>
        </>
      }
      right={<SignUpBuyerOptions />}
    />
  )
}

export default SignUpBuyer
